module.exports = __webpack_public_path__ + "static/media/pharmacy-inventory-management-system.e87c16cd.webp";